import { DueMonth } from "../../../../graphql/generated";

export const DueMonthOptions = {
  [DueMonth.Current]: "Due this month",
  [DueMonth.Next]: "Due next month",
  [DueMonth.NextTwo]: "Due next 2 months",
  [DueMonth.NextThree]: "Due next 3 months",
  [DueMonth.Total]: "Total",
};
